module.exports = __webpack_public_path__ + "static/media/ForgetFiles_PDF@1x.4f51bb91.png";